module.exports = __webpack_public_path__ + "static/media/faq.e6056a8f.png";